import {
  addFavorites,
  deleteFavorites,
} from '@/appsync/service/FavoriteMutationService';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { fetchFavoriteMenuIdList } from '@/appsync/service/PortalFavoriteQueryService';
import { FavoriteQueryParam, ID } from '@/types/type';

export const updateFavoriteStatus = async (param: FavoriteQueryParam) => {
  const menuIds: ID[] = await fetchFavoriteMenuIdList(param);
  if (menuIds.length) {
    const deleteQuery = deleteFavorites({ ...param, menuIds });
    await graphqlQuery(deleteQuery);
  }
  if (param.menuIds.length) {
    const addQuery = addFavorites(param);
    await graphqlQuery(addQuery);
  }
};
